import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import classNames from 'classnames';
import { register } from '../i18n';

// remove manuscript when all components are built and manuscript items are removed from
// preview, graded and review modes
import '../css/Player.scss';
import '../css/Manuscript.scss';
import '../css/TestItems.scss';
import '../css/CkeditorContentStyles.scss';
import '../css/Accessibility.scss';

import { LessonMode } from '../Constants';

import useLessonInit from '../hooks/useLessonInit';
import InternetMessage from '../lessonPlayer/components/InternetMessage';

import BackgroundShade from '../lessonPlayer/layout/BackgroundShade';
import ContentLayout from '../lessonPlayer/layout/ContentLayout';
import FooterLayout from '../lessonPlayer/layout/FooterLayout';
import FullpageLoader from '../lessonPlayer/components/FullpageLoader';
import HiddenAudioPlayer from '../lessonPlayer/components/HiddenAudioPlayer';
import ToolbarLayout from '../lessonPlayer/layout/ToolbarLayout';
import AccessibilityAnnouncer from '../lessonPlayer/components/AccessibilityAnnouncer';
import SatelliteToggle from '../lessonPlayer/components/tabbedFlyout/SatelliteToggle';

const t = register('AriaLabels');

const Preview = observer(() => {
  const {
    lessonManager,
    toolbarManager,
  } = useContext(MobXProviderContext);

  useLessonInit(LessonMode.PREVIEW);

  useEffect(() => {
    const className = `${LessonMode.PREVIEW} theme-override`;
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('class', className);
  });

  useEffect(() => {
    const handleWindowMessage = (event) => {
      if (event.data && event.data.type === 'related_tab_button_visibility') {
        if (typeof event.data.show === 'boolean') {
          lessonManager.setShouldShowRelatedTabButton(event.data.show);
        }
        if (typeof event.data.open === 'boolean') {
          lessonManager.setIsSatelliteOpen(event.data.open);
        }
      }
    };

    if (window.addEventListener) {
      window.addEventListener('message', handleWindowMessage, false);
    } else {
      window.attachEvent('onmessage', handleWindowMessage);
    }

    return () => {
      if (window.removeEventListener) {
        window.removeEventListener('message', handleWindowMessage, false);
      } else {
        window.detachEvent('onmessage', handleWindowMessage);
      }
    };
  }, [lessonManager]);

  return (
    <>
      <div id="ariaLiveMessage" aria-live="polite">{lessonManager.currentAriaMessage}</div>
      <AccessibilityAnnouncer />
      {/* eslint-disable-next-line no-nested-ternary */}
      {(lessonManager.isOnline && lessonManager.isLoaded && ((lessonManager.themeLoaded && lessonManager.translationsLoaded) || lessonManager.hasNoTheme)) ? (
        <div className={classNames('lesson-window', { highlightOn: toolbarManager.isHighlightOrStickyToolOn })}>
          <BackgroundShade>
            <HiddenAudioPlayer/>
            <header aria-label={t('mainMenu')}>
              <ToolbarLayout/>
            </header>
            <main role='main'>
              <SatelliteToggle />
              <ContentLayout/>
            </main>
            <nav>
              <FooterLayout/>
            </nav>
          </BackgroundShade>
        </div>
      ) : (!lessonManager.isOnline) ?
        (
          <InternetMessage/>
        )
        : (
          <FullpageLoader/>
        )}
    </>
  );
});
export default Preview;
